import commonMapping from "@/mapping/common";

const radio2g_preamble_list = [
  { value: "automatic", config: "auto", label: "sec_auto" },
  { value: "Long Preamble", label: "adva_wlan_pream_long", config: "long" },
  { value: "Short Preamble", label: "adva_wlan_pream_short", config: "short" },
];
const radio2g_tpc_mode_list = [
  { value: "100", label: "100%", config: "100" },
  { value: "50", label: "50%", config: "50" },
  { value: "25", label: "25%", config: "25" },
];
const radio5g_preamble_list = [
  { value: "automatic", config: "auto", label: "sec_auto" },
  { value: "Long Preamble", label: "adva_wlan_pream_long", config: "long" },
  { value: "Short Preamble", label: "adva_wlan_pream_short", config: "short" },
];
const radio5g_tpc_mode_list = [
  { value: "100", config: "100", label: "100%" },
  { value: "50", label: "50%", config: "50" },
  { value: "25", label: "25%", config: "25" },
];

const region_list = [
  {
    value: "Australia",
    config: "AUS",
    label: "coun_au_nz",
  },
  {
    value: "Europe",
    config: "GER",
    label: "coun_eu",
  },
  {
    value: "Korea",
    config: "KOR",
    label: "coun_ko",
  },
  {
    value: "New Zealand",
    config: "NZL",
    label: "coun_newzealand",
  },
  {
    value: "Canada",
    config: "CAN",
    label: "coun_ca",
  },
  {
    value: "Hong Kong",
    config: "HKG",
    label: "coun_hk",
  },
  {
    value: "India",
    config: "IND",
    label: "coun_in",
  },
  {
    value: "Japan",
    config: "JPN",
    label: "coun_jp",
  },
  {
    value: "North America",
    config: "USA",
    label: "coun_na",
  },
  {
    value: "China",
    config: "CHN",
    label: "coun_ch",
  },
  {
    value: "United Arab Emirates",
    config: "ARE",
    label: "coun_md_5",
  },
  {
    value: "Singapore",
    config: "SGP",
    label: "coun_si",
  },
  {
    value: "Vietnam",
    config: "VNM",
    label: "coun_vn",
  },
  {
    value: "Germany",
    config: "DEU",
    label: "coun_germany",
  },
];

export const advWireless = {
  region: region_list,
  radio2g_obss_coex_enable: commonMapping.intToBoolean,
  radio2g_preamble: radio2g_preamble_list,
  radio2g_tpc_mode: radio2g_tpc_mode_list,
  radio5g_preamble: radio5g_preamble_list,
  radio5g_tpc_mode: radio5g_tpc_mode_list,
  satellite_ignore_enable: commonMapping.intToBoolean,
};

export default advWireless;
